module.exports = __webpack_public_path__ + "staticcomp/img/cover.6c24042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/cover.jpg
// module id = ARso
// module chunks = 39